import { GatewayControleQuinquennal } from "@conformite/gateway";
import { useQueryClient } from "@tanstack/react-query";
import { ControleQuinquennalApi } from "../controle-quinquennal.api";
import { controleQuinquennalKeys } from "./controle-quinquennal.keys";

export type CQListAllParams = Omit<
  GatewayControleQuinquennal.ControleQuinquennalAdminSearchRequestType,
  "page" | "limit"
>;

export const useCQListAll = () => {
  const queryClient = useQueryClient();

  return (params: CQListAllParams) =>
    queryClient.fetchQuery({
      queryKey: controleQuinquennalKeys.export(params),
      queryFn: () => ControleQuinquennalApi.exportAll(params),
    });
};
